
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4681_13984)"}},[_c('path',{attrs:{"d":"M1.5 0A1.5 1.5 0 000 1.5v13A1.5 1.5 0 001.5 16h3v-2.5a1.5 1.5 0 013 0V16h3a1.5 1.5 0 001.5-1.5v-13A1.5 1.5 0 0010.5 0h-9zM2 7.5c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 01-.5-.5v-1zM5.5 7h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 01-.5-.5v-1c0-.275.225-.5.5-.5zm2.5.5c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 01-.5-.5v-1zM2.5 3h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 01-.5-.5v-1c0-.275.225-.5.5-.5zm2.5.5c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 01-.5-.5v-1zM8.5 3h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 01-.5-.5v-1c0-.275.225-.5.5-.5z","fill":"#910000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4681_13984"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h12v16H0z"}})])])])
          )
        }
      }
    